import { Body } from './components/body';
import { Header } from './components/header';
import { Loader } from './components/loader';
import * as Styled from './styled';

export const DetailReplaceEmployee = ({
  closeAction,
  constantReplaceEmployeeId,
}: {
  closeAction: () => void;
  constantReplaceEmployeeId?: number;
}) => (
  <Styled.Wrapper>
    <Loader />

    <Header closeAction={closeAction} />

    <Body
      constantReplaceEmployeeId={constantReplaceEmployeeId}
      closeAction={closeAction}
    />
  </Styled.Wrapper>
);
